<template>
	<div id="tutoredin-transition">
        <div class="image">
            <img :src="require('@/assets/email.svg')" style="width: 140px;" />
        </div>
        <div class="title">Confirm your email address</div>
        <div class="note note1">We sent a confrmation email to:</div>
        <div class="note note1 note2">{{register_user.email}}</div>
        <div class="note note1">Check your email and click on the</div>
        <div class="note note1">confrmation link to continue.</div>
        <div class="login">
            <el-button type="primary" style="width: 150px;" size="small" @click="onLogin" auto-insert-space="true">{{$t('router.login')}}</el-button>
        </div>
        <div class="resend" @click="onResend">{{$t('Resend')}}</div>

        <!-- <div class="title">{{$t('Confirm Your Email')}}</div>
        <div class="image">
            <i class="fa fa-send" style="font-size: 120px;color: #04d2c8;"></i>
        </div>
        <div class="note">{{note}}</div>
        <div class="login">
            <el-button type="primary" style="width: 150px;" @click="onLogin" auto-insert-space="true">{{$t('router.login')}}</el-button>
        </div>
		<div class="resend" @click="onResend">{{$t('Resend')}}</div> -->
	</div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import CommonApi from '@/api/common'

export default {
  data() {
    return {
    	token: '',
    	ok: false,
    	note: "",
        register_user: {}
    }
  },
  created() {
    this.register_user = this.$store.state.user.register_user || {};
    if(!this.register_user.id) {
        this.onLogin();
    }
    this.note = this.$t('Confirm Your Email Note');
    this.note = this.note.replace("%s", this.register_user.email);
  },
  methods: {
  	onLogin() {
        this.$router.push({path: "/login"})
  	},
    onResend() {
        CommonApi.activationNo(this.register_user).then(res => {
            this.$message.success(this.$t('dashboard.activation-success'));
        });
    }
  },
}
</script>
<style lang="less">
#tutoredin-transition {
	display: flex;
    align-items: center;
    flex-direction: column;
    position: relative;

    .title {
        font-weight: 600;
        font-size: 20px;
        margin-top: 50px;
    }

    .image {
        margin-top: 50px;
    }

    .note {
        margin-top: 40px;
        width: 350px;
        text-align: center;
        color: gray;
        line-height: 24px;
        font-size: 14px;
    }

    .note1 {
        margin-top: 10px;
    }

    .note2 {
        font-weight: 600;
        color: #2c3e50;
    }

    .login {
        margin-top: 40px;
    }

    .resend {
        margin-top: 20px;
        font-weight: 500;
        font-size: 12px;
        color: #04d2c8;
        cursor: pointer;
    }
}

</style>